__webpack_require__.p = "/tokens-products-global/referrals-hub/";